import React from 'react'
import PropTypes from 'prop-types'

import { Route, Routes, useLocation } from 'react-router-dom'

import { withUserStore } from '../../../contexts/UserStore'
import Account from './Account'
import Members from './Members'
import Teams from './Teams'
import AccountLexicon from './AccountLexicon'
import AccountExport from './AccountExport'
import OAuthApplications from './OAuthApplications'
import Lex from '../../Shared/Lex'
import TabNav from '../../Shared/TabNav'

const AccountContainer = ({ userStore }) => {
  const location = useLocation()
  const getAccount = () => userStore.account
  const sub = (location.pathname.split('/organization')[1] || '').replace(/^\//, '')

  const showMembers = userStore.getFeature('users', 'show') || getAccount()?.accountsUsers.length > 0
  const showTeams = userStore.getFeature('teams', 'show') || getAccount()?.teams.length > 0

  const tabs = [
    { key: 'details', label: <Lex term="details" />, onClick: () => userStore.appNavigate('organization'), active: sub === '' },
    ...(showMembers ? [{ key: 'members', dataCy: 'nav-organization-members', label: <Lex term="member" plural />, onClick: () => userStore.appNavigate('organization/members'), active: sub === 'members' }] : []),
    ...(showTeams ? [{ key: 'teams', dataCy: 'nav-organization-teams', label: <Lex term="team" plural />, onClick: () => userStore.appNavigate('organization/teams'), active: sub === 'teams' }] : []),
    { key: 'labels', dataCy: 'nav-organization-labels', label: <Lex term="labels" />, onClick: () => userStore.appNavigate('organization/labels'), active: sub === 'labels' },
    { key: 'oauth', dataCy: 'nav-organization-oauth', label: <Lex term="oauth-applications" />, onClick: () => userStore.appNavigate('organization/oauth'), active: sub === 'oauth' },
    { key: 'export', dataCy: 'nav-organization-export', label: <Lex term="export" />, onClick: () => userStore.appNavigate('organization/export'), active: sub === 'export' },
  ]

  return (
    <div className="container proxima-nova">
      <h5 className="text-center"><Lex term="organization-settings" /></h5>
      <div className="cbs-scope">
        <TabNav tabs={tabs} />
      </div>
      <div className="main-content">
        <Routes>
          <Route path="/" element={<Account account={getAccount()} />} />
          <Route path="members" element={<Members className="container" />} />
          <Route path="teams" element={<Teams account={getAccount()} />} />
          <Route path="labels" element={<AccountLexicon className="container" />} />
          <Route path="oauth" element={<OAuthApplications className="container" />} />
          <Route path="export" element={<AccountExport className="container" />} />
        </Routes>
      </div>
    </div>
  )
}

AccountContainer.propTypes = {
  account: PropTypes.object,
}

export default withUserStore(AccountContainer)
